import React, { useCallback } from 'react';
import { Switch } from 'tea-component';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import type { ISpecialDealsSwitchProps } from './types';
import './index.scss';

const DEFAULT_TOGGLE_DATA_KEY = 'specialDealsEnabled';

const SpecialDealsSwitch: React.FC<ISpecialDealsSwitchProps> = ({
  enabled = true,
  toggleDataKey = DEFAULT_TOGGLE_DATA_KEY,
  label = 'Special Deals',
  labelCN = '特别促销',
  data,
  changeData,
}) => {
  const { isEN } = useLocal();
  const dataKey = toggleDataKey || DEFAULT_TOGGLE_DATA_KEY;
  const checked = Boolean(data?.[dataKey]);
  const text = isEN ? label : labelCN;

  const handleChange = useCallback(
    (value: boolean): void => {
      changeData?.(dataKey, value);
    },
    [changeData, dataKey],
  );

  if (enabled === false) {
    return null;
  }

  return (
    <div className="dbh-special-deals-switch">
      <span className="dbh-special-deals-switch__label">{text}</span>
      <Switch value={checked} onChange={handleChange} />
    </div>
  );
};

export default SpecialDealsSwitch;
